import { SORUMLU_SECIM_LISTESI } from "../constants/requestUrls";

import { getRequest } from "../request";

const sorumluSecimListesi = (basvuruId) => {
  return getRequest({ url: SORUMLU_SECIM_LISTESI + "?basvuruId="+ basvuruId});
}

export default sorumluSecimListesi;